const showCard2CardPopup = () => {
    if (typeof window !== 'undefined') {
        window.show_P2P_frame();
    }
};

export default (ctx, inject) => {
    inject('showCard2CardPopup', showCard2CardPopup);
};
